import useClickActionT2 from '@/tracks/useClickActionT2';
import { StatusEnum } from '@/types/cart';
import { useMemo } from 'react';
import { twMerge } from 'tailwind-merge';
import { ProductCardProps } from '../../types';
import Favorite from '../favorite';
import { getProductCardExtraAttrs } from '@/utils/productFormat';
import ProductLabel from '../label';

const CardHeadLabel: React.FC<Partial<
  ProductCardProps & {
    labelNode?: React.ReactNode | (() => React.ReactNode);
    headerContainerCls?: string;
    exactTargetPos?: number;
    showBigOffLabel?: boolean;
    labelOffType?: string;
    bigOffLabelCls?: string;
    normalLabelCls?: string;
  }
>> = props => {
  const {
    data,
    showLabel = true,
    showFavorite = true,
    trackDataInDialog,
    positionInfoT2,
    supportPurchaseStatusNotify,
    headerContainerCls,
    exactTargetPos,
    showBigOffLabel = false,
    bigOffLabelCls = '',
    normalLabelCls = ''
  } = props;

  const { saveClick } = useClickActionT2();

  const isSoldOut = useMemo(() => {
    return data?.sold_status === StatusEnum?.sold_out;
  }, [data]);

  const displayBigOffLabel = useMemo(() => {
    return data?.label_list?.some(item => item.label_key === 'off') && data?.discount_percentage && showBigOffLabel;
  }, [data?.label_list, data?.discount_percentage, showBigOffLabel]);

  const renderHeadNode = () => {
    const _labelNode = typeof props.labelNode === 'function' ? props.labelNode() : props.labelNode;
    if (_labelNode) {
      return _labelNode;
    }
    return (
      <div
        id="card-head-label"
        className={twMerge(
          'box-border absolute left-0 top-200 justify-between items-center w-full px-200 py-0 z-[1] flex',
          headerContainerCls,
          displayBigOffLabel && bigOffLabelCls,
          !displayBigOffLabel && normalLabelCls
        )}>
        {showLabel && <ProductLabel {...props} />}

        {showFavorite && data?.category !== 'bundle' && data?.is_hotdish !== 'Y' && data?.sold_status && !isSoldOut && (
          <Favorite
            id={data?.product_id || data?.id}
            supportPurchaseStatusNotify={supportPurchaseStatusNotify}
            onClick={targetCollect => {
              saveClick(
                Object.assign(trackDataInDialog || {}, {
                  ...(positionInfoT2?.modSecPos || {}),
                  co: {
                    target_pos: exactTargetPos >= 0 ? exactTargetPos : positionInfoT2?.prodPos,
                    target_nm: data?.id || data?.product_id,
                    is_mkpl: data?.biz_type === 'seller'
                  },
                  ctx: {
                    ...positionInfoT2?.context,
                    extra_attrs: getProductCardExtraAttrs(data),
                    volume_price_support: data?.volume_price_support ? true : false
                  }
                }),
                targetCollect
              );
            }}
          />
        )}
      </div>
    );
  };

  return renderHeadNode();
};

export default CardHeadLabel;
